import { Drawer, Portal } from '@chakra-ui/react';

import { CloseButton } from '../CloseButton';
import { DragDrawerContent } from '../DragDrawer/DragDrawerContent';
import { DefaultContent } from './components/DefaultContent';
import { useIsMyAccount } from './useIsMyAccount';
import { useProfileDrawer } from './useProfileDrawer';

export const ProfileDrawer = () => {
  const isOpen = useProfileDrawer((s) => s.isOpen);
  const close = useProfileDrawer((s) => s.close);
  const isMyAccount = useIsMyAccount();

  return (
    <Drawer.Root
      size={{
        desktopDown: 'full',
        desktop: 'md',
      }}
      placement={{
        desktopDown: 'bottom',
        desktop: 'end',
      }}
      open={isOpen}
      onOpenChange={(state) => !state.open && close()}
    >
      <Portal>
        <Drawer.Positioner>
          <Drawer.Backdrop />
          <DragDrawerContent>
            <Drawer.CloseTrigger asChild>
              <CloseButton />
            </Drawer.CloseTrigger>
            <Drawer.Header>
              <Drawer.Title>
                {isMyAccount ? 'My account' : 'Profile details'}
              </Drawer.Title>
            </Drawer.Header>
            <DefaultContent />
          </DragDrawerContent>
        </Drawer.Positioner>
      </Portal>
    </Drawer.Root>
  );
};
